<!--
 * @Auther: 罗耀祖
 * @Date: 2022-04-15 14:26:25
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-15 14:35:09
 * @name: 查看评价
 * @Description: 查看评价
 * @FilePath: \project\src\components\afterSale\dialog-evaluate.vue
 * @Author: desktop
-->
<template>
  <el-dialog title="查看评价" width="650px" :visible.sync="show" @close="close">
    <div class="container">
      <div class="row">
        <div class="label">客户签字</div>
        <img :src="content.sign" class="sign"/>
      </div>
      <div class="row">
        <div class="label">客户评价</div>
        <div class="remark">{{content.remark}}</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import issueService from "@/module/issue/issue.service";
export default {
  data() {
    return {
      show: false,
      content: {},
    };
  },
  methods: {
    open(content) {
      this.content = content ? content : {};
      this.show = true;
    },
    close() {
      this.content = {};
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  @extend .et-flex-column-center;
  .row {
    width: 100%;
    @extend .et-flex-column-normal;
    &:not(:first-child) {
      margin-top: 20px;
    }
    .label {
      font-size: $Vars-font-miniTitle-size;
      margin-bottom: 10px;
    }
    .sign {
      width: 400px;
      margin: 0 auto;
    }
    .remark {
      width: 100%;
      box-sizing: border-box;
      padding: 20px;
      background: $Vars-background-light-gray;
    }
  }
}
</style>